import { FilterContext } from '../context/FilterProvider';
import { useContext } from 'react';

export const useFilter = () => {
    return useContext(FilterContext);
};
